import {Program} from 'src/app/model/cms-btv-core/program-model';
import * as InsertActions from '../actions/insert-program.actions';
import {InsertProgram} from '../interfaces/insert-program.interface';

export type Actions = InsertActions.Actions;

const initialState: InsertProgram = {
  program: Program,
  epgProgramId: '',
};

export function reducer(state: InsertProgram = initialState, action: Actions) {
  switch (action.type) {
    case InsertActions.INSERT_PROGRAM:
      return action.payload;
    case InsertActions.REMOVE_PROGRAM:
      state = null;
      return state;
    default:
      return state;
  }
}
